import React, { useState } from 'react';
import { leaveService } from '../services/leaveService';
import './EditLeaveBalanceDialog.css';

const EditLeaveBalanceDialog = ({
  employeeId,
  employeeName,
  currentAdjustment,
  calculatedDays,
  currentRemaining,
  onClose,
  onSuccess,
}) => {
  const [adjustment, setAdjustment] = useState(currentAdjustment.toString());
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAdjustmentChange = (e) => {
    const value = e.target.value;
    // Permettre les nombres négatifs et positifs
    if (value === '' || value === '-' || /^-?\d*\.?\d*$/.test(value)) {
      setAdjustment(value);
      setError('');
    }
  };

  const calculateNewTotal = () => {
    const parsed = parseFloat(adjustment);
    const adj = Number.isNaN(parsed) ? 0 : parsed;
    // différence entre le nouvel ajustement et l'ajustement actuel
    const delta = adj - currentAdjustment;
    // nouveau solde disponible à ce jour (après ajustement)
    return currentRemaining + delta;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const adjustmentValue = parseFloat(adjustment);
    if (isNaN(adjustmentValue)) {
      setError('Veuillez saisir un nombre valide');
      setLoading(false);
      return;
    }

    if (adjustmentValue < -50 || adjustmentValue > 50) {
      setError('L\'ajustement doit être entre -50 et +50 jours');
      setLoading(false);
      return;
    }

    try {
      await leaveService.updateLeaveBalance(employeeId, adjustmentValue, reason);
      onSuccess();
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Erreur lors de la mise à jour du solde';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const newTotal = calculateNewTotal();

  return (
    <div className="edit-leave-balance-overlay" onClick={onClose}>
      <div className="edit-leave-balance-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>Modifier le solde de congé</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="dialog-body">
          <div className="employee-info">
            <strong>{employeeName}</strong>
          </div>

          <div className="balance-info">
            <div className="info-row">
              <span className="label">Solde calculé automatiquement :</span>
              <span className="value">{calculatedDays} jours</span>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="adjustment">
                Ajustement manuel (positif ou négatif) :
              </label>
              <div className="adjustment-input-group">
                <input
                  type="text"
                  id="adjustment"
                  value={adjustment}
                  onChange={handleAdjustmentChange}
                  placeholder="0"
                  className="adjustment-input"
                />
                <span className="input-suffix">jours</span>
              </div>
              <small className="help-text">
                Valeur entre -50 et +50 jours. Utilisez un nombre négatif pour déduire des jours.
              </small>
            </div>

            <div className="form-group">
              <label htmlFor="reason">Raison (optionnel) :</label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Expliquez la raison de cet ajustement..."
                rows="3"
                className="reason-textarea"
              />
            </div>

            <div className="preview-section">
              <div className="preview-row">
                <span className="preview-label">Nouveau solde disponible à ce jour :</span>
                <span className={`preview-value ${newTotal < 0 ? 'negative' : ''}`}>
                  {newTotal.toFixed(0)} jours
                </span>
              </div>
            </div>

            {error && (
              <div className="error-banner">
                {error}
              </div>
            )}

            <div className="dialog-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Enregistrement...' : 'Enregistrer'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditLeaveBalanceDialog;

